import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue'; // Verifique o caminho
import ConhecaFresto from '../views/ConhecaFresto.vue';
import EventosPage from '../views/Eventos.vue';
import ProdutosPage from '../views/ProdutosPage.vue';
import ContatoPage from '../views/Contato.vue';
import PoliticasPrivacidade from '../views/PoliticasPrivacidade.vue';
import DeliveryPage from '../views/DeliveryPage.vue';
import TrabalheConosco from '../views/TrabalheConosco.vue';
import Unidades from '../views/Unidades.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { title: 'Fresto' }
  },
  {
    path: '/conheca-fresto',
    name: 'ConhecaFresto',
    component: ConhecaFresto,
    meta: { title: 'Conheça o Fresto' }
  },
  {
    path: '/eventos',
    name: 'EventosPage',
    component: EventosPage,
    meta: { title: 'Eventos' }
  },
  {
    path: '/produtos',
    name: 'ProdutosPage',
    component: ProdutosPage,
    meta: { title: 'Produtos' }
  },
  {
    path: '/contato',
    name: 'ContatoPage',
    component: ContatoPage,
    meta: { title: 'Contato' }
  },
  {
    path: '/politicas-privacidade',
    name: 'PoliticasPrivacidade',
    component: PoliticasPrivacidade,
    meta: { title: 'Políticas de Privacidade' }
  },
  {
    path: '/delivery',
    name: 'DeliveryPage',
    component: DeliveryPage,
    meta: { title: 'Delivery' }
  },
  {
    path: '/trabalhe-conosco',
    name: 'TrabalheConosco',
    component: TrabalheConosco,
    meta: { title: 'Entre para o nosso time' }
  },
  {
    path: '/unidades',
    name: 'UnidadesPage',
    component: Unidades,
    meta: { title: 'Unidades' }
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  if (to.name === 'Home') {
    document.title = 'Fresto';
  } else {
    document.title = `${to.meta.title || 'Título Padrão'} | Fresto`;
  }
  next();
});


export default router;